// extracted by mini-css-extract-plugin
export default {"productGrid":"r0-z","centerLink":"s0-z","productSection":"t0-z","item":"u0-z","ctaButton":"v0-z"};